import * as Babel from '@babel/standalone';

export function transpileReactCode(reactCode) {
  try {
    return Babel.transform(reactCode, {
      presets: ['react'],
    }).code;
  } catch (ex) {
    console.error('Error transpiling react code', ex);
    return '';
  }
}

export function isIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    return true;
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    return true;
  }

  // other browser
  return false;
}
